// extracted by mini-css-extract-plugin
export default {"success":"EmailConfirmThirdStep_success_lCBm2","button":"EmailConfirmThirdStep_button_LQPTJ"};